import type {
  AdministrativeLevel,
  VotingPlaceCatalogs,
  VotingPlaceFilters,
} from '@/types/votingPlace'

interface Props {
  catalogs: VotingPlaceCatalogs
  filters: VotingPlaceFilters
  onChange: (filters: VotingPlaceFilters) => void
  onClear: () => void
}

interface FilterFieldProps {
  label: string
  value?: number
  placeholder?: string
  disabled?: boolean
  options: AdministrativeLevel[]
  onChange: (value?: number) => void
}

function FilterField({
  disabled,
  label,
  onChange,
  options,
  placeholder = 'Selecciona',
  value,
}: FilterFieldProps) {
  return (
    <label className="voting-filter-field">
      <span>{label}</span>
      <select
        disabled={disabled}
        value={value ?? ''}
        onChange={(event) => onChange(event.target.value ? Number(event.target.value) : undefined)}
      >
        <option value="">{placeholder}</option>
        {options.map((option) => (
          <option key={option.codigo} value={option.codigo}>
            {option.nombre}
          </option>
        ))}
      </select>
    </label>
  )
}

export function VotingPlaceFilters({ catalogs, filters, onChange, onClear }: Props) {
  return (
    <div className="voting-filters" aria-label="Filtros de recintos electorales">
      <FilterField
        label="Provincia"
        options={catalogs.provincias}
        value={filters.provincia}
        onChange={(provincia) => onChange(provincia ? { provincia } : {})}
      />
      <FilterField
        disabled={!filters.provincia}
        label="Cantón"
        options={catalogs.cantones}
        value={filters.canton}
        onChange={(canton) => onChange(canton ? { provincia: filters.provincia, canton } : { provincia: filters.provincia })}
      />
      <FilterField
        disabled={!filters.canton}
        label="Parroquia"
        options={catalogs.parroquias}
        value={filters.parroquia}
        onChange={(parroquia) =>
          onChange(
            parroquia
              ? { provincia: filters.provincia, canton: filters.canton, parroquia }
              : { provincia: filters.provincia, canton: filters.canton },
          )
        }
      />
      <FilterField
        disabled={!filters.parroquia}
        label="Zona"
        options={catalogs.zonas}
        placeholder="Todas"
        value={filters.zona}
        onChange={(zona) => onChange(zona ? { ...filters, zona } : { ...filters, zona: undefined })}
      />

      <button className="voting-filters__clear" type="button" onClick={onClear}>
        Limpiar filtros
      </button>
    </div>
  )
}
